.cardRoot {
  &:not([data-selected]):hover {
    background-color: var(--mantine-color-dark-outline-hover);
  }

  &[data-selected] {
    --paper-border-color: var(--sdl-color-border-selected) !important;
  }

  &:active {
    background-color: var(--sdl-tint-hover-gray);
  }
}
